import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { useGetQuizzesQuery } from "../../features/quizzes/quizzeApi";

const Quiz = () => {
  const { id } = useParams();
  const { data: quezzes, isLoading } = useGetQuizzesQuery(id);
  const currentVieoQuiz = quezzes?.filter(
    (item) => item.video_id === parseInt(id)
  );
  console.log("🚀 ~ file: Quiz.js:12 ~ Quiz ~ currentVieoQuiz:", currentVieoQuiz)
  const [state, setState] = useState(currentVieoQuiz);
  console.log("🚀 ~ file: Quiz.js:13 ~ Quiz ~ state:", state)



  const handleSubmit = (e) => {
    e.preventDefault();
    // {
    //   "id": 1,
    //   "student_id": 2,
    //   "student_name": "Saad Hasan",
    //   "video_id": 1,
    //   "video_title": "Debounce Function in JavaScript - JavaScript Job Interview question",
    //   "totalQuiz": 2,
    //   "totalCorrect": 1,
    //   "totalWrong": 1,
    //   "totalMark": 10,
    //   "mark": 5
    //   }
    console.log("🚀 ~ file: Quiz.js:18 ~ Quiz ~ state", state);

  };

  const handleChange = (e) => {
    // setState((prevState) => ({
    //   ...prevState,
      

  };


  if (isLoading) return <div>Loading...</div>;

  if (currentVieoQuiz?.length === 0) {
    return (
      <>
        <Navbar />
        <section className="py-6 bg-primary">
          <div className="mx-auto max-w-7xl px-5 lg:px-0">
            <div className="mb-8">
              <h1 className="text-2xl font-bold">
                No Quiz Available for this video
              </h1>
            </div>
          </div>
        </section>
      </>
    );
  }
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="mb-8">
            <h1 className="text-2xl font-bold">
              Quizzes for "{currentVieoQuiz[0]?.video_title}"
            </h1>
            <p className="text-sm text-slate-200">
              Each question contains 5 Mark
            </p>
          </div>
          <from onSubmit={handleSubmit}>
          <div className="space-y-8 ">
            {currentVieoQuiz?.map((item) => (
              <div className="quiz" key={item.id}>
                <h4 className="question">Quiz 1 -{item.question}</h4>
                <div className="quizOptions">
                  {/* Option 1 */}
                 
                  {item?.options?.map((qus) => (
                    <label htmlFor={`${item.id}_${qus.id}`} key={qus.id}>
                      <input name={`${item.id}_${qus.id}`} type="checkbox" id={`${item.id}_${qus.id}`} value={qus.value} onChange={handleChange} />
                      {qus.option}
                    </label>
                  ))}
                </div>
              </div>
            ))}
           
          </div>
          <button className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 " type="submit">
            Submit
          </button>
          </from>
        </div>
      </section>
    </>
  );
};

export default Quiz;
